/**
 * GridFloor — 16×16 ground grid helper (T-1.1.4).
 *
 * Thin wrapper around THREE.GridHelper that pins the defaults to PRD FR-101:
 *   - size = 16, divisions = 16  → covers 16×16 with unit spacing
 *   - position y = 0              → XZ plane
 *   - colors chosen for contrast against the dark (#0a0a0a) canvas
 *
 * Single renderer / single scene — Constitution §2.3 #3. The grid is added
 * to MainScene's existing scene singleton; never instantiated against a
 * second renderer or scene.
 *
 * Why a factory function (not a class)? GridHelper is a leaf Object3D, no
 * lifecycle, no observers. A factory gives us a single call site for the
 * defaults and makes mocking trivial in jsdom.
 */
import { GridHelper } from 'three';

export const GRID_FLOOR_DEFAULT_SIZE = 16;
export const GRID_FLOOR_DEFAULT_DIVISIONS = 16;
export const GRID_FLOOR_CENTER_LINE_COLOR = 0x444444;
export const GRID_FLOOR_GRID_COLOR = 0x888888;

/**
 * Build a THREE.GridHelper pinned to the y=0 XZ plane.
 *
 * @param size       grid extent per side (default 16, must be ≥ 1)
 * @param divisions  cell count per side (default 16, must be ≥ 1)
 */
export function createGridFloor(
  size: number = GRID_FLOOR_DEFAULT_SIZE,
  divisions: number = GRID_FLOOR_DEFAULT_DIVISIONS,
): GridHelper {
  return new GridHelper(size, divisions, GRID_FLOOR_CENTER_LINE_COLOR, GRID_FLOOR_GRID_COLOR);
}
